export function getGenderOptions(t: any, showOnlyBaseGenders: boolean) {
  if (showOnlyBaseGenders) {
    return [
      { value: 'Male', label: t('male') },
      { value: 'Female', label: t('female') }
    ];
  }

  return [
    { value: 'Unspecified', label: t('rathernotsay') },
    { value: 'Male', label: t('male') },
    { value: 'Female', label: t('female') },
    { value: 'NonBinary', label: t('nonbinary') }
  ];
}
